exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".channel-actions__action__3ss81{-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;height:20px;line-height:20px;border-radius:0;color:-wix-colors-buttonsAndLinksColor-80;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:-wix-fonts-textFont-decoration;font-size:14px}.channel-actions__action__3ss81.channel-actions__info__1tBNe:hover .channel-actions__icon__3FzAR,.channel-actions__action__3ss81:hover{color:-wix-colors-buttonsAndLinksColor-100}.channel-actions__action__3ss81.channel-actions__info__1tBNe .channel-actions__icon__3FzAR{color:-wix-colors-buttonsAndLinksColor-80;font-size:15px}", ""]);

// exports
exports.locals = {
	"action": "channel-actions__action__3ss81",
	"info": "channel-actions__info__1tBNe",
	"icon": "channel-actions__icon__3FzAR"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/components/channel-actions/channel-actions.styl
// module id = 2906
// module chunks = 1